var app = app || {};

/**
 * Global / additional product search
 */
app.productsearch = (function() {
    'use strict';
    var moduleName = 'pws',
        carousel = null,
        searchData = null,
        $field = null,
        $filter = null,
        $results = null,
        autoSearch = false,
        self = {

        init: function() {
            app.main.getTemplate('partial-product-search', {}, true, function() {
                Handlebars.registerPartial('partial-search-form', $('#template-partial-search-form').html());
                Handlebars.registerPartial('partial-search-filter', $('#template-partial-search-filter').html());
                Handlebars.registerPartial('partial-search-results', $('#template-partial-search-results').html());
            });
        },

        /**
         * Product search form and filter functionality
         */
        enable: function(useModule) {
            if (useModule === 'enroll') {
                moduleName = 'enroll';
                autoSearch = true;
            }

            $field = $('#field-product-search-'+ moduleName);
            $filter = $('#product-filter-'+ moduleName);
            $results = $('#search-results');

            // doing this to avoid spamming google analytics with each keypress
            var searchTimer = null;

            if (moduleName === 'enroll') {
                searchData = defiant.getSnapshot(app[moduleName].getProducts());
                // pass this on to app.pws
                app.pws.setProducts(searchData);

            } else {
                searchData = app[moduleName].getProducts();
            }

            $('#form-product-search-'+ moduleName).on('submit', function(e) {
                e.preventDefault();
            });

            $field.focus(app.cart.hideAllItemCart);

            $field.off('keyup').on('keyup', function(e) {
                var query = $(this).val();

                if (query.length > 0) {
                    $('.btn-clear-search').show();

                } else {
                    $('.btn-clear-search').hide();
                }

                clearTimeout(searchTimer);

                if (e.keyCode === 13 && query.length > 1) {
                    self.renderSearch(self.doSearch(query));
                    return;
                }

                searchTimer = setTimeout(function() {
                    searchTimer = null;

                    if (query.length > 1 && autoSearch === true) {
                        app.main.track('Product Search', 'Query', query);
                        self.renderSearch(self.doSearch(query));
                    }
                }, 300);
            });

            $('.btn-search').on('click', function(e) {
                e.preventDefault();
                var query = $field.val();

                if (query.length > 1 && autoSearch === false) {
                    self.renderSearch(self.doSearch(query));
                }
            });

            $('.link-category').on('click', function(e) {
                e.preventDefault();

                self.clearSearch(true);

                var catID = $(this).data('id'),
                    results = defiant.search(searchData, '//*[categories='+ catID +']'),
                    categoryName = $(this).text();

                app.main.track('Product Search', 'Filter Products', 'Category: '+ categoryName);
                self.renderSearch(results, categoryName);

                $('.categories', $filter).removeClass('is-active');
                $('.link-filter').text(categoryName);
                $('.link-clear').addClass('is-active');
            });

            $('.link-filter').on('click', function(e) {
                e.preventDefault();
                var pos = $(this).position();

                $('.categories', $filter).css({
                    top: pos.top
                }).addClass('is-active');

                $('body').on('mousedown touchstart', function(e) {
                    if (e.target.className == 'link-category') return;
                    $('.categories', $filter).removeClass('is-active');
                    $(document).off('mousedown touchstart');
                });
            });

            $('.link-clear').on('click', function(e) {
                e.preventDefault();
                // self.renderSearch();
                // $('#link-filter').text(app.main.lang('label_filter_products'));
                // $(this).removeClass('is-active');
                self.clearSearch(true);
            });
        },

        doSearch: function(query) {
            var searchNodes = ['name', 'part_number', 'search_ids'],
                arrOr = [],
                results = [];

            searchNodes.forEach(function(searchNode) {
                var contains = '',
                    pieces = query.split(' '),
                    arrAnd = [];

                $results.addClass('is-loading');
                $('#product-search-carousel').empty();

                if (pieces.length > 1) {
                    pieces.forEach(function(str) {
                        if (str) {
                            arrAnd.push('contains('+ searchNode +', "'+ str +'")');
                        }
                    });
                    contains = arrAnd.join(' and ');

                } else {
                    contains = 'contains('+ searchNode +', "'+ query +'")';
                }

                if (contains) {
                    arrOr.push(contains);
                }
            });

            if (arrOr.length < 1) {
                self.clearSearch();
                return;
            }

            var searchStr = '//*[not(self::categories) and not(self::variants)] ['+ arrOr.join(' or ') +']';
            results = defiant.search(searchData, searchStr);

            // filter out duplicate products for search results only
            var productIDs = {};

            results = results.filter(function(item) {
                if (item.product_id in productIDs) {
                    return false;

                } else {
                    productIDs[item.product_id] = true;
                    return true;
                }
            });

            for (var i in results) {
                var rel = self.getRelevance(results[i].name, query);
                results[i].relevance = rel;
            }

            app.main.sort(results, 'relevance', 'desc');
            return results;
        },

        // adapted from admin
        // redraws products after search/filtering
        // skava only
        renderSearch: function(results, query) {
            var i, index;

            if (!query) {
                query = $field.val();
            }

            app.ga.event('search', { 'search_term': query});

            $results.removeClass('is-loading init');
            self.clearSearch();

            if (typeof results == 'object') {
                if (results.length > 0) {
                    $('.btn-clear-search').show();
                    $('.btn-clear-search').off('click').on('click', function() {
                        self.clearSearch(true);
                        $field.focus();
                    });

                    if (moduleName === 'enroll') {
                        // mark as added if already in the list
                        var enrollmentSelected = app.enroll.getEnrollmentSelected();

                        for (i=0; i<results.length; i++) {
                            var product = results[i];
                            var selectedList = enrollmentSelected['products'].concat(enrollmentSelected['monthly']);

                            index = app.enroll.getProductIndex(product.item_id, selectedList);

                            if (index > -1) {
                                product.added = true;

                                if (selectedList[index].quantity) {
                                    product.quantity = selectedList[index].quantity;
                                }

                            } else {
                                delete product.added;
                                product.quantity = 1;
                            }

                            // also loop through variants
                            if (product.variants) {
                                product.variants.forEach(function(variant) {
                                    index = app.enroll.getProductIndex(variant.item_id, selectedList);
                                    if (index > -1) {
                                        variant.added = true;

                                        if (selectedList[index].quantity) {
                                            variant.quantity = selectedList[index].quantity;
                                        }

                                    } else {
                                        delete variant.added;
                                        variant.quantity = 1;
                                    }
                                })
                            }
                        }

                    } else {
                        self.resultsModal(results);

                        $filter = $('#product-filter-'+ moduleName);
                        $results = $('#search-results');
                        $results.removeClass('is-loading init');
                    }

                    $('#product-search-carousel').html(app.main.getTemplate('products-carousel', { products: results }));

                    var $slides = $('#product-search-carousel .pws-item');

                    if (app.main.getSettings().product_card_enabled) {
                        $slides = $('.slide-container .product-card');
                    }

                    var totalSlides = $slides.length;

                    if (totalSlides > 1) {

                        var sliderProps = {
                            1379: Math.min(totalSlides, 4),
                            1050: Math.min(totalSlides, 4),
                            800: Math.min(totalSlides, 3),
                            600: Math.min(totalSlides, 2)
                        };

                        if (app.main.getSettings().skavaEnabled) {
                            sliderProps[1500] = Math.min(totalSlides, 4);
                        }

                        carousel = new Siema({
                            selector: '#product-search-carousel',
                            duration: 300,
                            easing: 'ease-out',
                            perPage: sliderProps,
                            startIndex: 0,
                            draggable: true,
                            multipleDrag: true,
                            threshold: 100,
                            loop: false,
                            rtl: false,
                            onInit: function() {
                                app.pws.updateCarouselCounter(this);
                            },
                            onChange: function() {
                                app.pws.updateCarouselCounter(this);
                            }
                        });

                        $('.control.prev', $results).off('click').on('click', function(e) {
                            e.preventDefault();
                            carousel.prev();
                        });

                        $('.control.next', $results).off('click').on('click', function(e) {
                            e.preventDefault();
                            carousel.next();
                        });

                        $('.control', $results).show();

                    } else {
                        // single product? hide carousel controls
                        $('.control', $results).hide();
                    }

                    $('.search-message').html('<p>'+ app.main.strReplace(app.main.lang('label_search_count'), results.length) +'</p>');

                    self.initCards();

                    // close the help popup if carousel is dragged
                    $('#product-search-carousel').on('mousedown touchstart', function(e) {
                        app.page.closeTip();
                        app.productcard.closeQuantity();
                    });


                } else {
                    if (moduleName === 'pws') {
                        // load empty modal
                        self.resultsModal(results);
                    }

                    // no results
                    self.clearSearch();
                    $('.search-message').html('<p>'+ app.main.strReplace(app.main.lang('label_search_empty'), query) +'</p>');
                }

            } else {
                // no results? clear search
                self.clearSearch();
            }
        },

        clearSearch: function(clearField) {
            if (carousel) {
                carousel.destroy();
                carousel = null;
            }

            if (clearField === true) {
                $field.val('');
                $('.btn-clear-search').hide();
            }

            $results.removeClass('is-loading');
            $('#product-search-carousel, .search-message').empty();
            $('.slider-counter', $results).empty()
            $('#search-results .control').hide();

            // clear any filtered results if applicable
            if ($('.link-clear').hasClass('is-active')) {
                $('.link-filter').text(app.main.lang('label_filter_products'));
                $('.link-clear').removeClass('is-active');
            }
        },

        // adapted from admin
        getRelevance: function(value, keyword) {
            if (!value) {
                return 0;
            }

            value = value.toLowerCase();
            keyword = keyword.toLowerCase();

            var index = value.indexOf(keyword);
            var word_index = value.indexOf(' '+ keyword);

            // value starts with keyword
            if (index == 0) {
                return 3;
            }

            // value doesn't start with keyword, but has the same word somewhere else
            else if (word_index != -1) {
                return 2;
            }

            // value contains keyword somewhere
            else if (index != -1) {
                return 1;
            }

            // no matches, no relevance
            else {
                return 0;
            }
        },

        initCards: function() {
            if (moduleName === 'enroll') {
                app.productcard.enable('additional');

            } else {
                // init the pws add-to-cart
                app.productcard.enable('pws');
            }
        },

        resultsModal: function(data) {
            $field.blur();
            app.productcard.setAlternateModal(true);
            app.modal.load('partial-search-results', {
                modal: true,
                query: $field.val(),
                results: data

            }, function() {
                // on modal close
                self.clearSearch(autoSearch);
                app.productcard.setAlternateModal(false);
                app.modal.init();
            });
        }
    };

    return self;
})();

